module.exports = __webpack_public_path__ + "img/icon_vod_like_on.4570ecd1.svg";